module.exports = __webpack_public_path__ + "static/media/mycart_product5.80bd9d6a.png";